import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if this is a club user before clearing storage
    const profile = localStorage.getItem('user_profile');
    let isClub = false;
    try {
      isClub = profile && JSON.parse(profile).is_club;
    } catch (e) {}

    // Clear tokens and user profile from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_profile');

    // Redirect to the appropriate login page
    navigate(isClub ? '/myclub/login' : '/login');
  }, [navigate]);

  return (
    <div>
      <p>Logging you out...</p>
    </div>
  );
};

export default Logout;
